import * as React from 'react'
import { useState } from 'react'
import { Overlay } from './Overlay'
import { styled } from '../../../../shared/styled-components'
import { Utils } from '../../../../shared/Utils'
import { Headline } from '../../../../shared/components/Headlines'
import { OverlayCloseButton } from './OverlayCloseButton'
import { Loading } from '../../../../shared/components/Loading'
import useAsyncEffect from 'use-async-effect'
import { OfficeInstance } from '../../../../models/Office'
import { OfficeListItemButtons } from '../OfficeListItemButtons'

interface IProps {
  office: OfficeInstance
  onClose?: () => any
}

export const VideoOverlay = ({ onClose, office }: IProps) => {
  return (
    <Overlay>
      <Container>
        <CloseButton onClick={onClose} />
        <VideoContainer>
          <Video
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            type="text/html"
            src={`https://www.youtube.com/embed/${office.videoId}?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0&origin=https://rechner.implacheck.de`}
          />
          <ButtonsContainer>
            <OfficeListItemButtons office={office} horizontal />
          </ButtonsContainer>
        </VideoContainer>
      </Container>
    </Overlay>
  )
}

const Container = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`

const CloseButton = styled(OverlayCloseButton)`
  position: absolute;
  bottom: calc(100% + 1rem);
  left: calc(100% + 1rem);
  @media (max-width: 950px) {
    left: calc(100% - 20px);
  }
`

const VideoContainer = styled.div`
  width: 50vw;
  &:before {
    content: '';
    float: left;
    padding-bottom: 56.25%;
  }
  @media (max-width: 950px) {
    width: 80vw;
  }
`

const Video = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const ButtonsContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
`
